export const TITLE = 'Deposit';

export const DESCRIPTION =
  "Set the amount the customer needs to pay upfront for the job. This amount should be between 10% and 50% of the job's total";
